import React, { Component } from 'react'
import Checkbox from '../../../../components/Checkbox'
import { FormGroup, Col } from 'react-bootstrap'

export default class CheckboxDropdown extends Component {

	render(){

		const { changeCheckStatus, addFilter, array, item, onChangeCheckbox } = this.props;

    let labelClass = (item.name) ? 'small-label col-md-6' : 'big-label'
    
    if (item.type === "checkbox-list-numbers") {
      return (
        <div className="col column-checkbox">
          <div className="title-row">
            <div>{item.name}</div>
          </div>
          <ul>
            <li><Checkbox
              classes="checkbox-sm checkbox-primary"
              label={1}
              name={1}
              checked={this._checkFiltersStatus(array, 1)}
              onChange={() => addFilter(item.name, 1)} /> </li>
            <li><Checkbox
              classes="checkbox-sm checkbox-primary"
              label={2}
              name={2}
              checked={this._checkFiltersStatus(array, 2)}
              onChange={() => addFilter(item.name, 2)} /> </li>
            <li><Checkbox
              classes="checkbox-sm checkbox-primary"
              label={3}
              name={3}
              checked={this._checkFiltersStatus(array, 3)}
              onChange={() => addFilter(item.name, 3)} /> </li>
            <li><Checkbox
              classes="checkbox-sm checkbox-primary"
              label={4}
              name={4}
              checked={this._checkFiltersStatus(array, 4)}
              onChange={() => addFilter(item.name, 4)} /> </li>
            <li><Checkbox
              classes="checkbox-sm checkbox-primary"
              label={5}
              name={5}
              checked={this._checkFiltersStatus(array, 5)}
              onChange={() => addFilter(item.name, 5)} /></li>
            <li><Checkbox
              classes="checkbox-sm checkbox-primary"
              label={'6+'}
              name={5}
              checked={this._checkFiltersStatus(array, 6)}
              onChange={() => addFilter(item.name, 6)} /></li>
          </ul>
        </div>  
      )
    }
    else{
      return(
        <div>
        {(item.name) ? (
            <p className="check-title hidden-xs">{item.name}</p>
          ) : ''
        }
          <ul>
          { item.options.map((i, index) =>
            <li key={index} className={labelClass}>
              <Checkbox
                classes="checkbox-sm checkbox-big"
                label={i.name}
                name={i.name}      
                checked={this._checkStatus(item.array, i)}   
                onChange={() => onChangeCheckbox(item, i)}        
               />             
            </li>
          )}
          </ul>
        </div>
      )  
    }			
	}

	_checkFiltersStatus(array, n){
		for (var i in array){
			if(array[i] === n){
				return true
			}
		}
	}

  _checkStatus(array, item) {
    if (array) {
      if (array.length > 0) {
        for (var i in array){
          if(array[i].id === item.id){
            return true
          }
        } 
      }
    }
    else return false    
  } 
}


// WEBPACK FOOTER //
// ./src/features/commons/Menu/SearchMenu/checkboxDropdown.js